import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_billing_rate_insert_or_update_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { billingContractLineId: number, rateId?: number, rangeStart?: number, rangeEnd?: number, option: string, rate?: number, minimumCharge?: number, typeId?: number }): Promise<{ result?: string, rateId?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billingContractLineId)) {
      $missingRequiredInParams.push('\'billingContractLineId\'');
    }
    if (isNil($inParams.option)) {
      $missingRequiredInParams.push('\'option\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

